import React, { useState } from 'react';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import { LocationIcon, HomeIcon, FilterIcon } from '../components/Icons/Icons';
import './Projects.css';

function Projects() {
  const [selectedCity, setSelectedCity] = useState('all');
  const [selectedType, setSelectedType] = useState('all');

  const cities = ['All Cities', 'Karachi', 'Lahore', 'Islamabad', 'Faisalabad', 'Multan', 'Peshawar'];
  const projectTypes = ['All Types', 'Residential', 'Commercial', 'Mixed-Use'];

  // Mock housing projects data
  const housingProjects = [
    {
      id: 1,
      name: 'Bahria Town Karachi',
      developer: 'Bahria Town (Pvt) Ltd',
      location: 'Super Highway, Karachi',
      city: 'Karachi',
      type: 'Residential',
      priceRange: '45 Lac - 5 Crore',
      totalUnits: '50,000+',
      status: 'Under Development',
      completion: '2026',
      amenities: ['Gated Community', 'Parks', 'Schools', 'Hospital', 'Shopping Malls'],
      image: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=800&q=80',
      featured: true
    },
    {
      id: 2,
      name: 'DHA Phase 11 Rahbar',
      developer: 'Defence Housing Authority',
      location: 'DHA Phase 11, Lahore',
      city: 'Lahore',
      type: 'Residential',
      priceRange: '60 Lac - 3 Crore',
      totalUnits: '15,000+',
      status: 'Launched',
      completion: '2025',
      amenities: ['Security', 'Community Center', 'Sports Complex', 'Parks', 'Mosque'],
      image: 'https://images.unsplash.com/photo-1582407947304-fd86f028f716?w=800&q=80',
      featured: true
    },
    {
      id: 3,
      name: 'Capital Smart City',
      developer: 'Habib Rafiq (Pvt) Ltd',
      location: 'Islamabad Highway',
      city: 'Islamabad',
      type: 'Residential',
      priceRange: '25 Lac - 2 Crore',
      totalUnits: '35,000+',
      status: 'Under Development',
      completion: '2027',
      amenities: ['Smart Infrastructure', 'Golf Course', 'International School', 'Healthcare', '5-Star Hotel'],
      image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&q=80',
      featured: true
    },
    {
      id: 4,
      name: 'Citi Housing Society',
      developer: 'Citi Housing',
      location: 'Main Multan Road, Lahore',
      city: 'Lahore',
      type: 'Residential',
      priceRange: '30 Lac - 1.5 Crore',
      totalUnits: '20,000+',
      status: 'Partially Developed',
      completion: '2024',
      amenities: ['Parks', 'Mosques', 'Schools', 'Commercial Areas', 'Healthcare'],
      image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&q=80',
      featured: false
    },
    {
      id: 5,
      name: 'Blue World City',
      developer: 'Blue Group of Companies',
      location: 'Chakri Road, Islamabad',
      city: 'Islamabad',
      type: 'Residential',
      priceRange: '20 Lac - 80 Lac',
      totalUnits: '25,000+',
      status: 'Under Development',
      completion: '2026',
      amenities: ['Water Park', 'Sports Complex', 'Food Street', 'Farmhouses', 'Tourist Resorts'],
      image: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=800&q=80',
      featured: false
    },
    {
      id: 6,
      name: 'Emaar Canyon Views',
      developer: 'Emaar Pakistan',
      location: 'Main Shahrah-e-Faisal, Karachi',
      city: 'Karachi',
      type: 'Mixed-Use',
      priceRange: '1 Crore - 10 Crore',
      totalUnits: '500+',
      status: 'Ready to Move',
      completion: '2023',
      amenities: ['Luxury Apartments', 'Retail Spaces', 'Gym', 'Swimming Pool', 'Security'],
      image: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=800&q=80',
      featured: false
    },
    {
      id: 7,
      name: 'PECHS Block 6',
      developer: 'Pakistan Employees Cooperative',
      location: 'PECHS, Karachi',
      city: 'Karachi',
      type: 'Residential',
      priceRange: '80 Lac - 4 Crore',
      totalUnits: '2,000+',
      status: 'Established',
      completion: 'Completed',
      amenities: ['Prime Location', 'Schools', 'Hospitals', 'Markets', 'Transport'],
      image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&q=80',
      featured: false
    },
    {
      id: 8,
      name: 'Park View City',
      developer: 'Vision Group',
      location: 'Islamabad Expressway',
      city: 'Islamabad',
      type: 'Residential',
      priceRange: '18 Lac - 90 Lac',
      totalUnits: '30,000+',
      status: 'Under Development',
      completion: '2025',
      amenities: ['Safari Park', 'Theme Park', 'International School', 'Hospital', 'Shopping Mall'],
      image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&q=80',
      featured: false
    }
  ];

  const filteredProjects = housingProjects.filter(project => {
    const cityMatch = selectedCity === 'all' || project.city === selectedCity;
    const typeMatch = selectedType === 'all' || project.type === selectedType;
    return cityMatch && typeMatch;
  });

  const featuredProjects = housingProjects.filter(p => p.featured);

  const handleProjectClick = (projectId) => {
    if (window.navigateTo) {
      window.navigateTo('project-detail');
    }
  };

  return (
    <div className="projects-page">
      <Header />

      <div className="projects-container">
        <div className="projects-hero">
          <div className="projects-hero-content">
            <h1>Housing Projects in Pakistan</h1>
            <p>Explore top housing societies and real estate developments</p>
          </div>
        </div>

        <div className="projects-content">
          <div className="filter-bar">
            <div className="filter-bar-content">
              <div className="filter-item">
                <label className="filter-bar-label">City</label>
                <select
                  value={selectedCity}
                  onChange={(e) => setSelectedCity(e.target.value)}
                  className="filter-bar-select"
                >
                  {cities.map((city, index) => (
                    <option key={index} value={index === 0 ? 'all' : city}>
                      {city}
                    </option>
                  ))}
                </select>
              </div>

              <div className="filter-item">
                <label className="filter-bar-label">Project Type</label>
                <select
                  value={selectedType}
                  onChange={(e) => setSelectedType(e.target.value)}
                  className="filter-bar-select"
                >
                  {projectTypes.map((type, index) => (
                    <option key={index} value={index === 0 ? 'all' : type}>
                      {type}
                    </option>
                  ))}
                </select>
              </div>

              <div className="filter-results">
                <FilterIcon size={20} color="#636e72" />
                <span>{filteredProjects.length} projects found</span>
              </div>
            </div>
          </div>

          <section className="featured-section">
            <h2 className="section-title">Featured Projects</h2>
            <div className="featured-grid">
              {featuredProjects.map(project => (
                <div
                  key={project.id}
                  className="featured-project-card"
                  onClick={() => handleProjectClick(project.id)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => e.key === 'Enter' && handleProjectClick(project.id)}
                >
                  <div className="featured-project-image">
                    <img src={project.image} alt={project.name} />
                    <div className="featured-badge">Featured</div>
                    <div className="status-badge">{project.status}</div>
                  </div>
                  <div className="featured-project-content">
                    <h3 className="project-name">{project.name}</h3>
                    <div className="project-developer">{project.developer}</div>
                    <div className="project-location">
                      <LocationIcon size={16} color="#636e72" />
                      <span>{project.location}</span>
                    </div>
                    <div className="project-details">
                      <div className="detail-item">
                        <span className="detail-label">Price Range</span>
                        <span className="detail-value">PKR {project.priceRange}</span>
                      </div>
                      <div className="detail-item">
                        <span className="detail-label">Total Units</span>
                        <span className="detail-value">{project.totalUnits}</span>
                      </div>
                      <div className="detail-item">
                        <span className="detail-label">Completion</span>
                        <span className="detail-value">{project.completion}</span>
                      </div>
                    </div>
                    <div className="project-amenities">
                      {project.amenities.slice(0, 3).map((amenity, index) => (
                        <span key={index} className="amenity-tag">{amenity}</span>
                      ))}
                      {project.amenities.length > 3 && (
                        <span className="amenity-tag">+{project.amenities.length - 3} more</span>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className="all-projects-section">
            <h2 className="section-title">All Projects</h2>
            <div className="projects-grid">
              {filteredProjects.map(project => (
                <div
                  key={project.id}
                  className="project-card"
                  onClick={() => handleProjectClick(project.id)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => e.key === 'Enter' && handleProjectClick(project.id)}
                >
                  <div className="project-image">
                    <img src={project.image} alt={project.name} />
                    <div className="project-status-badge">{project.status}</div>
                  </div>
                  <div className="project-content">
                    <h3 className="project-title">{project.name}</h3>
                    <div className="project-dev">{project.developer}</div>
                    <div className="project-loc">
                      <LocationIcon size={14} color="#636e72" />
                      <span>{project.location}</span>
                    </div>
                    <div className="project-info">
                      <div className="info-item">
                        <span className="info-label">Price</span>
                        <span className="info-value">{project.priceRange}</span>
                      </div>
                      <div className="info-item">
                        <span className="info-label">Units</span>
                        <span className="info-value">{project.totalUnits}</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className="why-invest-section">
            <h2>Why Invest in Housing Projects?</h2>
            <div className="invest-grid">
              <div className="invest-card">
                <div className="invest-icon">
                  <HomeIcon size={32} color="var(--color-primary)" />
                </div>
                <h3>Modern Amenities</h3>
                <p>Access to world-class facilities including parks, schools, hospitals, and shopping centers.</p>
              </div>
              <div className="invest-card">
                <div className="invest-icon">
                  <LocationIcon size={32} color="var(--color-primary)" />
                </div>
                <h3>Prime Locations</h3>
                <p>Strategic locations with excellent connectivity to major highways and city centers.</p>
              </div>
              <div className="invest-card">
                <div className="invest-icon">
                  <FilterIcon size={32} color="var(--color-primary)" />
                </div>
                <h3>High ROI</h3>
                <p>Proven track record of property value appreciation and strong return on investment.</p>
              </div>
            </div>
          </section>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Projects;
